export var ready = function (cb) {
    // TODO: 前置校验
    cb === null || cb === void 0 ? void 0 : cb();
};
